import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverviewComponent } from './overview/overview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { BarchartComponent } from './barchart/barchart.component';
import { MultiToggleComponent } from './multi-toggle/multi-toggle.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {  RouterModule } from '@angular/router';
import { ReportingFrameComponent } from './reporting-frame/reporting-frame.component';
import { MaterialModule } from '@sdbn/appclient';
import { ReportDaySelectionWidget } from './report-day-selection/report-day-selection.component';

import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';
import { ForecastModule } from './forecast/forecast.module';
import { StatusModule } from './status/status.module';

@NgModule({
  declarations: [
    OverviewComponent,
    BarchartComponent,
    MultiToggleComponent,
    ReportingFrameComponent,
    ReportDaySelectionWidget
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    RouterModule,
    CommonUIElementsModule,
    CommonLayoutModule,
    CommonTranslationModule,
    StructureNodeSelectionModule,
    ForecastModule,
    StatusModule
  ]
})
export class ReportingModule { }
